import http from "../../http-common";

class AllBooksService {
    getAllBooks() {
        return http.get(`/education/allbooks`);
    }
}

export default new AllBooksService();
